export default "__VITE_ASSET__df530133__"